import { forwardRef, useEffect, useRef } from "react";

type IndeterminateCheckboxProps = {
  indeterminate: any;
  children?: React.ReactNode;
};

export const IndeterminateBodyCheckbox = forwardRef<HTMLInputElement, IndeterminateCheckboxProps>(({
  indeterminate,
  ...rest
}, ref) => {
  const defaultRef = useRef();
  const resolvedRef: any = ref || defaultRef;

  useEffect(() => {
    resolvedRef.current.indeterminate = indeterminate;
  }, [resolvedRef, indeterminate]);

  return <div className="form-check">
    <input type="checkbox"
      className="form-check-input"
      ref={resolvedRef}
      {...rest}
    />
    <label htmlFor="form-check-input" className="form-check-label"></label>
  </div>;
});
